import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import './../../../Style/Produce.scss'
import { deleteAlert, errorAlert, handleSuccess, updateAlert } from "../../../Components/Alerts";
import { ApiLink } from "../../../APILink/ApiLink";
import authHeader from "../../../Auth/authHeader";
import { AiFillAppstore } from "react-icons/ai";
import { Paper } from "@mui/material";
import "jspdf-autotable";
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import DataGridWithActions from "../../../Components/DataGridWithActions";
import Autocomplete from "@mui/material/Autocomplete";
import { ElementsParagraph, TitleElements } from "../../../Components/HeadersCRUD-s";
import { AddLinkButton, LinkAndClickButton } from "../../../Components/AddElementsButton";
import { ArticleReceptureDetails, ProduceArticle, produceTransactionGrid } from "./ProduceGrid";
import { MdEdit } from "react-icons/md";
import { HeaderPaperComponent } from "../../../Components/HeaderPaperComponent";
import { FiscalYearContext } from "../../../FiscalYear/FiscalYearContext";
import { TextareaAutosize } from '@mui/material';
import DataGridComponent from "../../../Components/DataGridComponent";
import CancelModal from "../../../Components/CancelModal";
import PrintFletProdhimin from "../../../Print/PrintFletProdhimin";
import ButtonGroup from '@mui/material/ButtonGroup';
import MuiButton from '@mui/material/Button';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Popper from '@mui/material/Popper';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
export default function Produce(props) {
    const [showDetails, setShowDetails] = useState(true);
    const { fiscalYear } = useContext(FiscalYearContext)

    const [hasElectronicSeal, setHasElectronicSeal] = useState(null);
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);

    const [articleProductionID, setArticleProductionID] = useState(0);
    const [compoundArticleField, setCompoundArticleField] = useState(null);
    const [articleUnit, setArticleUnit] = useState(null);

    const [produceTransactions, setProduceTransactions] = useState([]);
    const [receptureDetails, setReceptureDetails] = useState([]);

    const [articleProductions, setArticlProductions] = useState([]);

    const [produceArticleData, setProduceArticleData] = useState([]);

    const [changeButton, setChangeButton] = useState(false)
    const [showModal, setShowModal] = useState(false);

    const [minDate, setMinDate] = useState('');
    const [maxDate, setMaxDate] = useState('');

    const [companiesData, setCompaniesData] = useState([]);
    const [headerData, setHeaderData] = useState([]);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    const changeButtons = () => {
        setDisabledQty(false);
        fetchrecepture(articleProductionID);

    }
    useEffect(() => {
        setMinDate(`${fiscalYear}-01-01`);
        setMaxDate(`${fiscalYear}-12-31`);
    }, [fiscalYear])

    const [disabledQty, setDisabledQty] = useState(true);

    const headers = authHeader();

    const [formData, setFormData] = useState({
        TransactionID: "",
        InvoiceNr: "",
        Date: "",
        Comment: "",
    });

    const [formDetailData, setFormDetailData] = useState({
        ArticleID: "",
        HistoryID: "",
        PriceWithoutVAT: "",
        QtyInput: "",
        Total: ""
    });

    const [showEditModal, setShowEditModal] = useState(false);

    const fetchProduceTransactions = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Produce/produceTransactions', { headers, params: { fiscalYear: fiscalYear } });
            setProduceTransactions(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    //ky kod i kthen detajet e artikullit te prodhuar
    const fetchproduceArticle = async (id) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Produce/articleByTransaction', {
                headers,
                params: { id: id }
            });

            fetchArticlesProduction();
            fetchrecepture(response.data[0].ArticleID);
            setArticleProductionID(response.data[0].ArticleID)
            setCompoundArticleField(response.data[0].ArticleName);
            setArticleUnit(response.data[0].UnitName);

            setFormDetailData({
                ArticleID: response.data[0].ArticleID,
                HistoryID: response.data[0].HistoryID,
                PriceWithoutVAT: response.data[0].PriceWithoutVAT,
                QtyInput: response.data[0].QtyInput,
                Total: response.data[0].Total
            });
            return response.data || [];
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage || "Gabim nga serveri."}`);
            } else if (error.request) {
                errorAlert("Serveri nuk është i arritshëm. Kontrolloni lidhjen me internetin ose provoni më vonë.");
            } else {
                errorAlert(`Gabim: ${error.message}`);
            }

            return [];
        }
    };

    const handleConfirm = () => {
        setShowModal(false);
        setChangeButton(false);
        setShowEditModal(false);
        setShowDetails(true);
    };
    const closeEditForm = () => {
        setShowDetails(true);
        setShowEditModal(false);
        setFormDetailData({
            ArticleComponentsID: "",
            ArticleProductionID: "",
            ArticlesID: "",
            Qty: ""
        });
        setDisabledQty(true);
        fetchProduceTransactions();
    }

    // Kodi per fshirjen e nje elementi ne databaz 
    const handleDelete = async (deleteItemId) => {
        try {
            // const response = 
            await axios.delete(
                ApiLink.API_URL + 'Produce/deleteTransactions' + `/${deleteItemId}`, { headers }
            );
            deleteAlert("Fletë prodhimi është fshirë me sukses");
            fetchProduceTransactions();
        } catch (error) {
            deleteAlert("Fletë prodhimi nuk është fshirë");
        }
    };

    const fetchArticlesProduction = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'CompoundArticle', { headers });
            setArticlProductions(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const fetchCompaniesData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Companies/getCompanyDetails', { headers });
            setCompaniesData(response.data);
            // setCompanyName(response.data[0].CompanyName);
            // setCompanyEmail(response.data[0].Email);
            // setcompanyID(response.data[0].CompanyID);
            setHasElectronicSeal(response.data[0].ElectronicSeal);
            // console.log(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const fetchHeaderData = async (invNumber) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Produce/GetPrintHeaderDetails', { headers, params: { invNumber: invNumber, actionType: "PRD", fiscalYear: fiscalYear } });
            setHeaderData(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const handleInputChangeQty = (event) => {
        const { name, value } = event.target;
        setFormDetailData({ ...formDetailData, [name]: value });
    };

    const handleNewSubmit = (event, action) => {
        event.preventDefault();

        if (!formDetailData.QtyInput) {
            errorAlert("Plotësoni sasinë, për të vazhduar");
            return
        }

        const payload = {
            ArtProdDto: {
                TransactionID: formData.TransactionID,
                ArticleProductionID: formDetailData.ArticleID,
                Date: formData.Date,
                QtyInput: formDetailData.QtyInput,
                Price: totalAvg,
            },
            ReceptureDetails: receptureDetails, // Array nga useState
        };
        axios.post(ApiLink.API_URL + "Produce/produceProduct", payload, { headers, params: { action: action } })
            .then(() => {
                handleSuccess("Sasia u ndryshua me sukses");
                setDisabledQty(true);
            })
            .catch((error) => {
                console.error("Gabim gjatë dërgimit:", error);

                if (error.response) {
                    console.error("Përgjigja nga serveri:", error.response.data);

                    if (error.response.status === 409) {
                        errorAlert(error.response.data);
                    } else if (error.response.status === 400) {
                        errorAlert("Të dhënat nuk janë të sakta. Kontrolloni nëse keni plotësuar çdo fushë.");
                    } else if (error.response.status === 500) {
                        errorAlert(`Gabim i brendshëm i serverit: ${error.response.data}`);
                    } else {
                        errorAlert(`Ndodhi një gabim: ${error.response.data}`);
                    }
                } else if (error.request) {
                    errorAlert("Serveri nuk është i arritshëm. Kontrolloni lidhjen tuaj me internetin.");
                } else {
                    errorAlert("Ndodhi një gabim i panjohur gjatë dërgimit të të dhënave.");
                }
            });
    };

    // Kodi per shfaqjen e formes per editimin e te dhenave ne databaz 
    const handleEdit = (item) => {
        setShowEditModal(true);
        setShowDetails(false);
        fetchHeaderData(item.InvoiceNr);
        fetchproduceArticle(item.TransactionID);
        setFormData({
            TransactionID: item.TransactionID,
            InvoiceNr: item.InvoiceNr,
            Date: item.Date,
            Comment: item.Coment,
        });
    };
    // Kodi per ruajtjen e te dhenave pas editimint 
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
        setChangeButton(true);

    };

    const handleChangeTransaction = (event) => {
        event.preventDefault();
        axios
            .put(ApiLink.API_URL + 'Produce/changeTransaction', formData, { headers })
            .then((response) => {
                setChangeButton(false);
                updateAlert("Të dhënat u edituan me sukses")
                fetchProduceTransactions();
            })
            .catch((error) => {
                errorAlert("Deshtoi editimi i recepturës")
            });
    }

    const fetchrecepture = async (artID) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Produce/articleReceptureDetails', {
                headers,
                params: { compoudArticleID: artID, invNumber: formData.InvoiceNr, fiscalYear: fiscalYear }
            });
            console.log(response.data);
            setReceptureDetails(response.data);
            return response.data || [];
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage || "Gabim nga serveri."}`);
            } else if (error.request) {
                errorAlert("Serveri nuk është i arritshëm. Kontrolloni lidhjen me internetin ose provoni më vonë.");
            } else {
                errorAlert(`Gabim: ${error.message}`);
            }

            return [];
        }
    };

    const rows = produceTransactions.map((item, index) => ({
        id: ++index,
        inv: (`PRD-${fiscalYear}-${item.InvoiceNr}`),
        // inv: item.InvoiceNr,
        date: new Date(item.Date).toLocaleDateString("en-GB"),
        client: item.Coment,
        total: item.Total,
        deleteItemId: item.TransactionID,
        rowInfo: item
    }));

    const receptureRows = receptureDetails.map((item, index) => ({
        id: index + 1, // Përdor index + 1 në vend të ++index
        recepture: item.ArticleName,
        qty: formDetailData.QtyInput !== 0 ? Number(item.Qty) * Number(formDetailData.QtyInput) : item.Qty,
        price: item.CmimiMesatar,
        value: formDetailData.QtyInput !== 0 ? (Number(item.CmimiMesatar) * (Number(item.Qty) * Number(formDetailData.QtyInput))) : item.TotalAmount,
        artUnit: item.UnitName
    }));

    //Select list for Clients
    const handleAutocompleteChangeCompoundArticle = (event, value) => {
        if (value) {
            setCompoundArticleField(value);
            alert(compoundArticleField);

        } else {
            setCompoundArticleField(null);
        }
    };

    const defaultPropsCompoundArticles = {
        options: articleProductions,
        getOptionLabel: (option) =>
            `${option.ArticleProduction == 2 ? "Gjysem Produkt" : "Produkt i Prodhuar"} - ${option.ArticleName}` || "",
        renderOption: (props, option) => (
            <>
                <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
                    <span>
                        {option.Barcode}-{option.ArticleProduction == 2 ? "Gjysem Produkt" : "Produkt i Prodhuar"} <br />
                        <b> {option.ArticleName}</b>
                    </span>
                </li>
            </>
        ),
    };

    // useEffect(() => {
    //     if (formDetailData.ArticleID) {
    //         const selectedArticle = articleProductions.find(option => option.ArticleID === formDetailData.ArticleID);
    //         setCompoundArticleField(selectedArticle ? selectedArticle.ArticleName : null);
    //     }
    // }, [formDetailData.ArticleID, articleProductions]);

    //ruhet totali i vleres se seciles recepture
    const [totalAvg, setTotalAvg] = useState(0);

    useEffect(() => {
        if (receptureDetails.length > 0 && formDetailData.QtyInput > 0) {
            let total = receptureDetails.reduce((sum, item) => sum + item.TotalAmount, 0);
            setTotalAvg(total);
        } else {
            setTotalAvg(0); // Reset në rast se s'ka të dhëna
        }
    }, [receptureDetails, formDetailData.QtyInput]);

    // Përditëso array-n me të dhëna dinamike
    useEffect(() => {
        setProduceArticleData([
            {
                id: 1,
                ArticleName: compoundArticleField,
                Qty: formDetailData.QtyInput,
                CmimiMesatar: totalAvg,
                TotalAmount: Number(formDetailData.QtyInput) * Number(totalAvg),
                TransactionID: formDetailData.TransactionID,
                UnitName: articleUnit
            }
        ]);
    }, [compoundArticleField, articleUnit, formDetailData.QtyInput, totalAvg, formDetailData.TransactionID]);

    const produceArticleRow = produceArticleData.map((item, index) => ({
        id: ++index,
        recepture: item.ArticleName,
        qty: item.Qty,
        price: item.CmimiMesatar,
        value: item.TotalAmount,
    }));

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            let nextField;
            switch (e.target.id) {
                case 'QtyInput':
                    if (disabledQty === false) {
                        handleNewSubmit(e, "edit");
                    }
                    break;
                default:
                    return;
            }
            if (nextField && nextField.select) {
                nextField.focus();
                nextField.select(); // Shtoni këtë rresht për të selektuar tekstin
            }
        }
    };

    useEffect(() => {
        fetchProduceTransactions();
    }, [fiscalYear]);

    useEffect(() => {
        fetchCompaniesData();
    }, [])
    return (
        <div className="NewProduce__Container">
            <CancelModal
                open={showModal}
                onClose={() => setShowModal(false)}
                title="Konfirmim"
                description="Jeni të sigurt që dëshironi të anuloni ndryshimet?"
                confirmText="po"     // Custom confirm button text
                cancelText="jo"      // Custom cancel button text
                onConfirm={() => handleConfirm()}
            />

            <br></br>
            <br></br>
            {showEditModal && (
                <div className="NewProduce__Container">
                    <TitleElements
                        icon={MdEdit}
                        title="Ndryshimi i Prodhimit"
                    />
                    <hr></hr>
                    <div className="NewProduce__Container__AllButtons">
                        <div style={{ display: "flex", }}>
                            {/* <div>
                                <InsertCompoundArticle fetchData={fetchArticlesProduction} type="insert" />
                            </div>
                            <div style={{ marginLeft: "5px" }}>
                                <InsertRecepture fetchData={fetchSimpleArticles} type="insert" />
                            </div> */}
                        </div>
                        <div style={{ display: "flex" }}>
                            <div style={{ marginLeft: "5px" }}>
                                <ButtonGroup
                                    variant="contained"
                                    ref={anchorRef}
                                >
                                    <PrintFletProdhimin details={headerData} companyDetails={companiesData} produceArticle={produceArticleData} recepture={receptureRows} hasElectronicSeal={hasElectronicSeal} />
                                    <MuiButton
                                        style={{ width: "30px", height: "35px", marginTop: "10px", borderRadius: ("0 5px 5px 0"), backgroundColor: "#4E7B67" }}
                                        aria-controls={open ? 'split-button-menu' : undefined}
                                        aria-expanded={open ? 'true' : undefined}
                                        // aria-label="select print option"
                                        aria-haspopup="menu"
                                        onClick={handleToggle}
                                    >
                                        <ArrowDropDownIcon />
                                    </MuiButton>
                                </ButtonGroup>
                                <Popper
                                    sx={{ zIndex: 1 }}
                                    open={open}
                                    anchorEl={anchorRef.current}
                                    role={undefined}
                                    transition
                                    disablePortal
                                >
                                    {({ TransitionProps, placement }) => (
                                        <Grow
                                            {...TransitionProps}
                                            style={{
                                                transformOrigin:
                                                    placement === 'bottom' ? 'center top' : 'center bottom',
                                            }}
                                        >
                                            <Paper>
                                                <ClickAwayListener onClickAway={handleClose}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={hasElectronicSeal} // Lidh me `ElectronicSeal`
                                                                onChange={(event) => setHasElectronicSeal(event.target.checked)} // Përditëson `ElectronicSeal` kur klikohet
                                                            />
                                                        }
                                                        label="Shfaq Vulen Elektronike"
                                                    />
                                                </ClickAwayListener>
                                            </Paper>
                                        </Grow>
                                    )}
                                </Popper>
                            </div>
                            {changeButton ? (
                                <>
                                    <div style={{ marginLeft: "5px" }}>
                                        <LinkAndClickButton
                                            text="Ruaj"
                                            link="#"
                                            onClick={handleChangeTransaction}
                                        />
                                    </div>
                                    <div style={{ marginLeft: "5px" }}>
                                        <LinkAndClickButton
                                            text="Anulo"
                                            link="#"
                                            onClick={() => {
                                                setShowModal(true);
                                            }}
                                        />
                                    </div>
                                </>
                            ) : (
                                <div style={{ marginLeft: "5px" }}>
                                    <LinkAndClickButton
                                        text="Mbyll"
                                        link="#"
                                        onClick={() => {
                                            closeEditForm();
                                            setShowDetails(true);
                                            setShowEditModal(false);
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    {/* <div className='header_paper2'></div> */}
                    <HeaderPaperComponent />
                    <Paper>
                        <div className='NewProduce__Container__FirstForm'>
                            <form>
                                <Box
                                    noValidate
                                    autoComplete="off"
                                >
                                    <div className="NewProduce__Container__FirstForm__Row1" >
                                        <div className="NewProduce__Container__FirstForm__Row1__div">
                                            <TextField
                                                className="NewProduce__Container__Form__TextField__1"
                                                id="InvoiceNr"
                                                label="Numri i Fletë Prodhimit"
                                                variant="outlined"
                                                type="text"
                                                name='InvoiceNr'
                                                value={"PRD-" + fiscalYear + "-" + formData.InvoiceNr}
                                                readOnly
                                            />
                                        </div>
                                        <div className="NewProduce__Container__FirstForm__Row1__div">
                                            <TextField
                                                className="NewProduce__Container__Form__TextField__1"
                                                id="date"
                                                type="date"
                                                variant="outlined"
                                                name='Date'
                                                value={formData.Date.substring(0, 10)}
                                                onChange={handleInputChange}
                                                inputProps={{
                                                    min: minDate, // Kufizimi minimal i datës
                                                    max: maxDate, // Kufizimi maksimal i datës
                                                }}
                                            />
                                        </div>
                                        <div className="NewProduce__Container__FirstForm__Row1__div">
                                            <TextareaAutosize
                                                className="NewProduce__Container__Form__Description"
                                                id="Comment"
                                                placeholder='Përshkrimi'
                                                type="text"
                                                autoComplete='off'
                                                name='Comment'
                                                value={formData.Comment}
                                                onChange={handleInputChange}
                                                style={{ resize: 'none' }}
                                            />

                                        </div>
                                    </div>
                                </Box>
                            </form>
                            <br></br>
                            <br></br>
                            <div style={{ backgroundColor: "gainsboro " }}>
                                <form className='header_paper' onKeyPress={handleKeyPress}>
                                    <Box
                                        // component="form"
                                        sx={{
                                            '& .MuiTextField-root': { m: 1.3, width: '41ch' },
                                        }}
                                        noValidate
                                        autoComplete="off"
                                    >
                                        <div className='NewProduce__Container__FirstForm__Row1'>
                                            <div style={{ width: "90%" }}>
                                                <Autocomplete
                                                    fullWidth
                                                    // sx={{ m: 2 }}
                                                    {...defaultPropsCompoundArticles}
                                                    id="ArticleCompoundID"
                                                    includeInputInList
                                                    onChange={handleAutocompleteChangeCompoundArticle}
                                                    readOnly
                                                    renderInput={(params) => (
                                                        <TextField {...params}
                                                            label="Artikulli i përbërë"
                                                            style={{ width: "100%" }}
                                                        />
                                                    )}
                                                    value={articleProductions.find(option => option.ArticleID === formDetailData.ArticleID) || null}
                                                />
                                            </div>
                                            <div className='box3'>
                                                <TextField
                                                    className="AccountingSheet__Container__Form__TextField__5"
                                                    id="QtyInput"
                                                    label="Sasia"
                                                    variant="outlined"
                                                    autoComplete="off"
                                                    name='QtyInput'
                                                    disabled={disabledQty}
                                                    value={formDetailData.QtyInput}
                                                    onChange={handleInputChangeQty}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </div>
                                            <div className="butonat">
                                                <button
                                                    type="button" // 🔹 Ndrysho nga "submit" në "button"
                                                    disabled={disabledQty}
                                                    className="btn btn-primary float-end"
                                                    style={{ background: "#284945", width: "110px", marginLeft: "15px" }}
                                                    onClick={(event) => handleNewSubmit(event, "edit")} // 🔹 Ndrysho nga "onSubmit" në "onClick"
                                                >
                                                    Prodho
                                                </button>

                                            </div>
                                        </div>
                                    </Box>
                                </form>
                            </div>
                        </div>
                        <div>
                            <DataGridComponent
                                columns={ProduceArticle({ changeButtons })}
                                rows={produceArticleRow}
                                height={"auto"}
                            />
                        </div>
                        <div>
                            <ElementsParagraph text="Ne tabelë janë paraqitur recepturat qe shërbejnë për ta prodhuar produktin e zgjedhur" />
                            <DataGridComponent
                                columns={ArticleReceptureDetails}
                                rows={receptureRows}
                                height={"auto"}
                            />
                            <br></br>
                        </div>
                    </Paper>
                </div>

            )}
            {showDetails && (
                <div className="shfaqePermbajtjen">
                    <div className="header_flex">
                        <TitleElements
                            icon={AiFillAppstore}
                            title="Prodhimi"
                        />
                        <AddLinkButton
                            text="Krijo Prodhim"
                            icon="bi bi-plus-circle"
                            link="/produc/newProduce"
                        />
                    </div>
                    <ElementsParagraph text="Forma e prodhimit: Menaxhoni, shtoni, editoni dhe fshini prodhimin." />
                    <DataGridWithActions
                        columns={produceTransactionGrid}
                        rows={rows}
                        handleEdit={handleEdit}
                        handleDelete={handleDelete}
                        showPayment={false}
                        height={500}
                    />
                </div>
            )}
        </div >
    )
}